<template>
  <h-bar-chart-card
    title="안전보건 예산 집행률 현황"
    :value="data"
    :total="total"
    unit="%"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="!!projectId"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></h-bar-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'
import HBarChartCard from "@/components/HBarChartCard.vue";

/**
 * 안전보건 예산 집행률 현황s
 */
export default {
  name: 'HeathSafetyBudgetExecutionRateChart',
  components: {HBarChartCard, DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
  },
  computed: {
    projectId () {
      return parseInt(this.$route.params.proj_id) || 0
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 15,
      boardId: 155,
      data: [{label: '데이터 없음', value: 0}],
      total: '0',
      cache: {},
    }
  },
  created() {
    switch (this.projectId) {
    case 2:
    case 3:
      this.boardId = 106; // A형
      break;
    case 4:
      this.boardId = 154; // B형
      break;
    case 5:
      this.boardId = 155; // C형
      break;
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData(currentYear, depth) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (!depth) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          depth,
          excludeProjectIds: [5],
        };

        const data = await this.$store.dispatch("summary/LOAD_DONUT_15_DETAIL", params);
        this.cache[cacheKey] = data;
        return data;
      }
    },

    async loadGraph () {
      const data = await this.loadDetailData()

      let graph2Data = [];
      if (!this.projectId) {
        graph2Data = data.project;
      } else {
        switch (this.getLevel) {
        case 1:
        case 2:
          graph2Data = data.company;
          break;
        case 3:
          graph2Data = data.field;
          break;
        case 4:
        default:
          graph2Data = data.budgetItem;
          break;
        }
      }

      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      const currentData = graph2Data[currentYear][currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.rate,
          budget: row.budget,
          budgetExe : row.used,
        });
      }
      // list를 budgetExe 기준으로 내림차순 정렬한다.
      list.sort((a, b) => {
        return b.budget - a.budget;
      });

      this.total = `${data.monthly[currentYear][currentMonth]}`;
      this.data = list;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    },
    parseNumber(str) {
      // 쉼표를 제거합니다.
      str = str.replace(/,/g, '');
      // 문자열을 정수로 파싱합니다.
      return parseInt(str);
    },
    percentage(a, b) {
      // A를 B로 나눈 결과를 구합니다.
      const result = (a / b) * 100;
      // 소수점 2자리까지 반올림합니다.
      const roundedResult = Math.round(result * 100) / 100;
      // 문자열로 변환합니다.
      const resultString = roundedResult.toString();
      // 소수점이 없는 경우 '.00'을 덧붙입니다.
      if (!resultString.includes('.')) {
        return `${resultString  }.00`;
      }
      // 소수점이 하나만 있는 경우 '0'을 덧붙입니다.
      if (resultString.split('.')[1].length === 1) {
        return `${resultString  }0`;
      }
      // 소수점이 둘 이상인 경우 그대로 반환합니다.
      return resultString;
    }
  },
}
</script>

<style scoped>

</style>
